import { Card } from 'antd';
import React from 'react';
const CiteAndDataPage = () => {
  return (
    <div className="bg-white h-screen overflow-auto">
      <div className="max-w-5xl px-10 mx-auto my-10">
        <div className="text-4xl pb-8 font-thin">
          <span>Data Availability and Citation</span>
        </div>
        <div className="font-light">
          <p>
            The raw metagenomics composition data can be downloaded from the {' '}
            <a
              href="https://www.microbiomeatlas.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Human Gut Microbiome Atlas
            </a> website. For the full network data presented in this platform, they can be downloaded via this {' '}
            <a
              href="ftp://gutmicro.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              LINK
            </a>.
          </p>
          <br />
          <p>
            If you use any part of GutMicroNet for your research or publications, please cite the following papers and the original cohort data (Reference column on {' '}
            <a
              href="https://www.biorxiv.org/content/10.1101/2021.11.10.468051v2.supplementary-material"
              target="_blank"
              rel="noopener noreferrer"
            >
              Supplementary Table 1
            </a>):
          </p>
          <br />
          <ol className="ml-4">
            <li>  1.	Muhammad Arif#, Theo Portlock#, Cem Güngör, Elif Koç, Berkay Özcan, Oğuzhan Subaş, Buğra Çakmak, Hassan Turkez, Mathias Uhlén, Adil Mardinoglu, Saeed Shoaie (2021), GutMicroNet: an interactive platform for gut microbiome interaction exploration, Biorxiv (Pre-print). {' '}
              <a
                href="https://doi.org/10.1101/2021.11.10.468051"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINK
              </a></li>
            <br />
            <li>  2.	Saeed Shoaie, Sunjae Lee, Mathieu Almeida, Gholamreza Bidkhori, Nicolas Pons, Florian Onate, Emmanuelle Chatelier, Neelu Begum, Ceri Proffitt, Dorinês Rosário, Stefania Vaga, Junseok Park, Kalle von Feilitzen, Fredric Johansson, Victoria Meslier, Azadeh Harzandi, Lucie Etienne-Mesmin, Lindsey Edwards, Vincent Lombard, Franck Gauthier, Claire Steves, David Gomez-Cabrero, Bernard Henrissat, Doheon Lee, Debbie Shawcross, Stéphanie Blanquet-Diot, Gordon Proctor, Lars Engstrand, Adil Mardinoglu, Jens Nielsen, Stanislav Ehrlich, Mathias Uhlen (2021), Global and temporal state of the human gut microbiome in health and disease, Research Square (Pre-print). {' '}
              <a
                href="https://doi.org/10.21203/rs.3.rs-339282/v1"
                target="_blank"
                rel="noopener noreferrer"
              >
                LINK
              </a></li>
          </ol>
          <br />

          <p>
          <li>  
          The Jupyter Notebook for generating the networks can be found {' '}

              <a
                href="https://github.com/sysmedicine/gutmicronet"
                target="_blank"
                rel="noopener noreferrer"
              >
                here.
              </a></li>
              
            </p>

          <p>
            <b>NOTE:</b> If your publication journal does not allow citing pre-prints, please contact Saeed Shoaie (saeed.shoaie [at] scilifelab.se) and Muhammad Arif (me [at] muharif.net).
          </p>
        </div>
      </div>
    </div>
  );
};

export default CiteAndDataPage;
